import React from 'react'
import './SocialLinks.scss'
import {Col } from 'reactstrap'
import {FaFacebook, FaEnvelope} from 'react-icons/fa6'

export default function SocialLinks() {
  return (
    <Col md="4" className="SocialLinks mb-2 mb-md-0  text-center">
      <a href='https://www.facebook.com/Voicesbookseries'
         target="_blank" rel="noopener noreferrer" className="mr-3">
        <FaFacebook size={24} />
      </a>
      <a
        href='mailto:janehartenstein@gmail.com'
        rel='noopener noreferrer'
        target='_blank'
      >
        <FaEnvelope size={24} />
      </a>
    </Col>
  )
}
